import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { DailyTaskDetailReport } from './Pages';

export const DailyTaskDetailReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={DailyTaskDetailReport} />
       
    </Fragment>
)